import React from "react";
import s from "./style.module.css";
import { Heading, Standfirst } from "../Elements";
import cn from "classnames";

const ContentBlock = ({ id, title, intro, children, icon, plain }) => {
  return (
    <div className={cn(s.wrap, { [s.plain]: plain })} id={id}>
      {icon && <span className={s.icon}>{icon}</span>}
      {title && <Heading className={s.title}>{title}</Heading>}

      {intro && <Standfirst>{intro}</Standfirst>}
      {children && children}
    </div>
  );
};

export default ContentBlock;
